import Logo from '../../assests/images/logo2.png';
import "./Loader.css";

const Loader = ({ showDisplay }) => {
  return (
    <>
      <div style={{ display: showDisplay }}>
        <div className="loader-container">
          <img src={Logo} alt="Loading..." className="loader-logo" />
        </div>
      </div>
    </>
  );
};

export default Loader;